import { useQuery } from '@tanstack/react-query';
import { Select } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { ReactNode, useContext } from 'react';
import { getEmployeesDropdown } from '@martech-solution/utils/apis';
import { AppContext } from 'src/contexts/app.context';
import { SelectProps } from '@martech-solution/utils/types';

type Props = SelectProps & {
  exclusionEmployee?: number;
  value?: string;
  departmentId?: number;
  placeholder?: ReactNode;
  size?: SizeType;
  disabled?: boolean;
  hasUserName?: boolean;
};

export default function EmployeeSelect({
  exclusionEmployee,
  value,
  style,
  allowClear = true,
  onChange,
  departmentId,
  disabled,
  placeholder,
  size = 'middle',
  hasUserName
}: Props) {
  const { isUserAdmin } = useContext(AppContext);
  const deptId = isUserAdmin ? undefined : departmentId;

  const employeesDropdownQuery = useQuery({
    queryKey: ['employeesDropdown', deptId, hasUserName],
    queryFn: () => getEmployeesDropdown(deptId, undefined, undefined, hasUserName),
    staleTime: 60 * 1000
  });

  return (
    <Select
      allowClear={allowClear}
      value={employeesDropdownQuery.isFetching ? undefined : value}
      style={style}
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
      options={employeesDropdownQuery.data?.data
        .filter((item) => item.id !== exclusionEmployee)
        .map((item) => ({
          value: String(item.id),
          label: `${item.code} - ${item.fullName}`
        }))}
      size={size}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={employeesDropdownQuery.isFetching}
    />
  );
}
